export default "__VITE_ASSET__Cwr7R6zA__"